<div class="quantity-stepper-field">
  <label class="quantity-stepper-label" [id]="id + '-label'">{{ label }}</label>
  <div class="quantity-stepper" [attr.aria-labelledby]="id + '-label'">
    <button
      type="button"
      class="quantity-stepper-button"
      [id]="id + '-decrement'"
      [disabled]="control.value <= 0"
      [attr.aria-label]="
        'QUANTITY_STEPPER.DECREASE_ARIA_LABEL' | translate: { label: label }
      "
      (click)="decrement()"
    >
      −
    </button>
    <span class="quantity-stepper-value" [id]="id">{{ control.value }}</span>
    <button
      type="button"
      class="quantity-stepper-button"
      [id]="id + '-increment'"
      [disabled]="max !== undefined && control.value >= max"
      [attr.aria-label]="
        'QUANTITY_STEPPER.INCREASE_ARIA_LABEL' | translate: { label: label }
      "
      (click)="increment()"
    >
      +
    </button>
  </div>
</div>
